var module = angular.module('octopusApp.projects');

module.controller('ProjectProcessController', function ($scope, $stateParams, projectState, $q, busy, pageTitle, octopusRepository, $state, pluginRegistry, octoDialog, $uibModal, $location, unsavedChanges){
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var projectId = $stateParams.projectId;
    $scope.project = null;

    $scope.actionClass = function(action) {
        return action.ActionType.replace(".", "").toLowerCase();
    };

    $scope.canHaveChildren = function(step) {
        return _.some(step.Actions, function (a) { 
            var actionDefinition = pluginRegistry.getDeploymentAction(a.ActionType);
            return actionDefinition.canHaveChildren(step);
        });
    };

    var getTags = function(allOptions, selectedOptions) {
        if (allOptions.length === 0) {
            return "";
        }

        var result = [];

        _.each(selectedOptions, function (e) {
            if (allOptions.indexOf(e.Id) >= 0) {
                result.push(e.Name);
            }
        });

        return result.join(",");
    };

    function init() {

        var environmentPromise = octopusRepository.Environments.all().then(function (environments) {
            $scope.environments = environments;
        });

        isLoading.promise(projectState.load().then(function (project) {
            $scope.project = project;
            pageTitle(project.Name + " deployment process");

            var lifeCyclesPromise = octopusRepository.Lifecycles.get(project.LifecycleId)
                .then(octopusRepository.Lifecycles.preview)
                .then(function (lifecycle) {
                    $scope.lifecycle = lifecycle;
                });
            var channelsPromise = octopusRepository.Projects.getChannels(project).then(function (channels) {
                $scope.channels = channels;
            });

            var deploymentProcesPromise = projectState.deploymentProcessAsync.then(function (deploymentProcess) {
                $scope.deploymentProcess = deploymentProcess;
                $scope.builtInFeedPackageActions = _.filter(
                    _.flatten(
                        _.map(deploymentProcess.Steps,
                            function (s) {
                                return s.Actions;
                            })),
                    function (a) {
                        return a.Properties["Octopus.Action.Package.FeedId"] === 'feeds-builtin';
                    });
            });

            return $q.all([environmentPromise, lifeCyclesPromise, channelsPromise, deploymentProcesPromise]);
        }).then(function(){
            _.each($scope.deploymentProcess.Steps, function (s) {
                _.each(s.Actions, function (a) {
                    a.environments = getTags(a.Environments || [], $scope.environments);
                    a.excludedEnvironments = getTags(a.ExcludedEnvironments || [], $scope.environments);
                    a.channels = getTags(a.Channels, $scope.channels.Items);
                });
            });
        }).then(updateIncludedSets)
        .then(function() {
            unsavedChanges.saved();
        }));
    }

    var updateIncludedSets = function() {
        return isLoading.promise(octopusRepository.LibraryVariableSets.all({contentType: 'ScriptModule'}).then(function(libraryVariableSets){
            $scope.includedScriptModules = _.filter(libraryVariableSets, function(set){
                var included = _.find($scope.project.IncludedLibraryVariableSetIds, function(id){
                    return id === set.Id;
                });
                return included;
            });
        }));
    };

    $scope.configureLibraryScriptModules = function() {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/views/include_variables_dialog.html',
            controller: 'ProjectVariablesIncludeController',
            resolve: {
                current: function () { return _.toArray($scope.project.IncludedLibraryVariableSetIds); },
                contentType: function() { return 'ScriptModule'; },
                contentTypeDesc: function() { return 'Script Module'; }
            }
        }).result.then(function(result) {
            if (result) {
                if (!_.isEqual(result, $scope.project.IncludedLibraryVariableSetIds)) {
                    $scope.project.IncludedLibraryVariableSetIds = _.toArray(result);
                    return isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function(project){
                        $scope.project = project;
                        return updateIncludedSets();
                    }));
                }
            }
        });
    };

    $scope.addStep = function (stepId) {
        if (!stepId) {
            $location.path("/projects/" + $scope.project.Slug + "/steptemplates");
        }
        else {
            $location.path("/projects/" + $scope.project.Slug + "/childsteptemplates/" + stepId);
        }
    };

    var modifyProcess = function(stepId, actionId, callback) {
        isLoading.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id)
            .then(function (deploymentProcess) {
                var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });
                if (!step) { return; }
                                
                var action = _.find(step.Actions, function (a) { return a.Id === actionId; });

                var result = callback(deploymentProcess, step, action);

                if (result) {
                    isSaving.promise(isLoading.promise(octopusRepository.DeploymentProcesses.save(deploymentProcess).then(function () {
                        $state.reload();
                    })));
                }
            }));
    };

    $scope.disableAction = function(stepId, actionId) {
        modifyProcess(stepId, actionId, function (process, step, action) {
            action.IsDisabled = true;
            return true;
        });
    };
    
    $scope.enableAction = function(stepId, actionId) {
        modifyProcess(stepId, actionId, function (process, step, action) {
            action.IsDisabled = false;
            return true;
        });
    };
    
    $scope.disableAllActions = function(stepId) {
        modifyProcess(stepId, null, function (process, step, action) {
            _.each(step.Actions, function (a) {
                a.IsDisabled = true;
            });
            return true;
        });
    };
    
    $scope.enableAllActions = function(stepId) {
        modifyProcess(stepId, null, function (process, step, action) {
            _.each(step.Actions, function (a) {
                a.IsDisabled = false;
            });
            return true;
        });
    };

    $scope.cloneStep = function(stepId, actionId) {
        modifyProcess(stepId, actionId, function (process, step, action) {
            var nameOfActionExists = function (steps, actionName) {
                return _.filter(steps, function (s) {
                    return (s.Name === actionName) || (_.filter(s.Actions, function (a) { return a.Name === actionName; }).length > 0);
                }).length > 0;
            };

            var getNewActionName = function (steps, clonedAction) {
                var suffix = "";
                var counter = 1;
                while (nameOfActionExists(steps, clonedAction.Name + suffix)) {
                    suffix = " - clone (" + counter + ")";
                    counter++;
                }

                return clonedAction.Name + suffix;
            };

            var stepNameExists = function (steps, stepName) {
                return _.filter(steps, function (s) {
                    return s.Name === stepName;
                }).length > 0;
            };

            var getNewStepName = function (steps, clonedStep) {
                var suffix = "";
                var counter = 1;
                while (stepNameExists(steps, clonedStep.Name + suffix)) {
                    suffix = " - clone (" + counter + ")";
                    counter++;
                }

                return clonedStep.Name + suffix;
            };

            if (action && step.Actions.length > 1) {
                var clonedAction = JSON.parse(JSON.stringify(action));
                clonedAction.Id = "";
                clonedAction.Name = getNewActionName(process.Steps, clonedAction);

                var actionIndex = _.indexOf(step.Actions, action);
                step.Actions.splice(actionIndex + 1, 0, clonedAction);
            } else {
                var clonedStep = JSON.parse(JSON.stringify(step));
                clonedStep.Id = "";
                clonedStep.Name = getNewStepName(process.Steps, clonedStep);
                for (var i = 0;i < clonedStep.Actions.length;i++) {
                    clonedStep.Actions[i].Id = "";
                    clonedStep.Actions[i].Name = getNewActionName(process.Steps, clonedStep.Actions[i]);
                }
                var stepIndex = _.indexOf(process.Steps, step);
                process.Steps.splice(stepIndex + 1, 0, clonedStep);
            }

            return true;
        });
    };
    
    $scope.moveOut = function(stepId, actionId) {
        modifyProcess(stepId, actionId, function (process, step, action) {
            var newStep = {
                Name: action.Name,
                RequiresPackagesToBeAcquired: step.RequiresPackagesToBeAcquired,
                Properties: step.Properties,
                Condition : step.Condition,
                StartTrigger: step.StartTrigger,
                Actions: [
                    action
                ]
            };

            var name = newStep.Name;
            var i = 1;
            var isStep = function(s) {
                return s.Name === newStep.Name;
            };
            while (true) {
                if (!_.some(process.Steps, isStep)){
                    break;
                }
                newStep.Name = name + " " + i;
                i++;
            }

            var actionIndex = _.indexOf(step.Actions, action);
            step.Actions.splice(actionIndex, 1);

            var stepIndex = _.indexOf(process.Steps, step);
            process.Steps.splice(stepIndex + 1, 0, newStep);

            return true;
        });
    };

    $scope.moveIn = function(stepId, actionId) {
        var steps = _.filter($scope.deploymentProcess.Steps, function (s) { 
            return s.Id !== stepId && $scope.canHaveChildren(s);
        });

        var step = _.find($scope.deploymentProcess.Steps, function (s) { return s.Id === stepId; });
        var action = _.find(step.Actions, function (a) { return a.Id === actionId; });

        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/views/step_list_dialog.html',
            controller: 'StepListController',
            resolve: {
                action: function () { return action; },
                steps: function () { return steps; }
            }
        }).result.then(function(result) {
            var moveIt = function() {
                modifyProcess(stepId, actionId, function (process, step, action) {
                    // Copy the action to the new step
                    var newParent = _.find(process.Steps, function (s) { return s.Id === result.Id; });
                    newParent.Actions.splice(newParent.Actions.length, 0, action);

                    // Remove action from the old step
                    var actionIndex = _.indexOf(step.Actions, action);
                    step.Actions.splice(actionIndex, 1);

                    // Remove parent step if no actions left
                    if (step.Actions.length === 0) {
                        var stepIndex = _.indexOf(process.Steps, step);
                        process.Steps.splice(stepIndex, 1);
                    }
                    return true;
                });
            };

            if (result) {
                if (step.Properties["Octopus.Action.TargetRoles"] !== result.Properties["Octopus.Action.TargetRoles"]) {
                    octoDialog.messageBox(
                        "Confirm target role change",
                        "This step previously targeted a different set of roles than the step you are moving it to. This means the step is now likely to run on a different set of machines. Are you sure you wish to move the step?",
                        [{
                        result: 'yes',
                        label: 'Move',
                        cssClass: 'btn-success'
                        }, {
                        result: 'cancel',
                        label: 'Cancel'
                        }]).then(function (result) {
                        if (result === 'yes') {
                            moveIt();
                        }
                        });
                } else {
                    moveIt();
                }


                
            }
        });
    };

    $scope.deleteStep = function(stepId, actionId) {
        octoDialog.asyncConfirm({
            title: "Delete step",
            message: "Are you sure you wish to delete this step? This action cannot be undone.",
            executeButtonClass: "btn-warning",
            executeButtonText: "Delete",
            execute: function (dialog) {
                dialog.busy.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id).then(function (deploymentProcess) {
                    var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });
                    if (step) {
                        var deleteStep = false;

                        if (actionId) {
                            var action = _.find(step.Actions, function (a) { return a.Id === actionId; });
                            if (action) {
                                var actionIndex = _.indexOf(step.Actions, action);
                                step.Actions.splice(actionIndex, 1);

                                if (step.Actions.length === 0) {
                                    deleteStep = true;
                                }
                            }
                        } else {
                            deleteStep = true;
                        }

                        if (deleteStep) {
                            var stepIndex = _.indexOf(deploymentProcess.Steps, step);
                            deploymentProcess.Steps.splice(stepIndex, 1);
                        } else if (step.Actions.length === 1) {
                            step.Name = step.Actions[0].Name;
                        }
                    }

                    dialog.busy.promise(octopusRepository.DeploymentProcesses.save(deploymentProcess).then(function() {
                        dialog.dismiss();
                        $state.reload();
                    }));
                }));
            }
        });
    };

    $scope.reorderSteps = function(stepId) {
        octoDialog.sort({
            title: "Reorder Steps",
            saveButtonText: "Save",
            load: function(dialog) {
                dialog.busy.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id).then(function (deploymentProcess) {
                    var items = [];

                    if (stepId) {
                        var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });
                        dialog.render(_.map(step.Actions, function (action) {
                            return {
                                id: action.Id,
                                name: action.Name
                            };
                        }));
                    } else {
                        dialog.render(_.map(deploymentProcess.Steps, function (action) {
                            return {
                                id: action.Id,
                                name: action.Name
                            };
                        }));
                    }
                }));
            },
            save: function (items, dialog) {
                dialog.busy.promise(octopusRepository.DeploymentProcesses.get($scope.deploymentProcess.Id).then(function (deploymentProcess) {
                    if (stepId) {
                        var step = _.find(deploymentProcess.Steps, function (s) { return s.Id === stepId; });

                        var oldActions = step.Actions;
                        step.Actions = _.map(items, function (id) {
                            return _.find(oldActions, function (s) { return s.Id === id; });
                        });
                    } else {
                        var oldSteps = deploymentProcess.Steps;
                        deploymentProcess.Steps = _.map(items, function (id) {
                            return _.find(oldSteps, function (s) { return s.Id === id; });
                        });
                    }

                    dialog.busy.promise(octopusRepository.DeploymentProcesses.save(deploymentProcess).then(function() {
                        dialog.dismiss();
                        $state.reload();
                    }));
                }));
            }
        });
    };

    $scope.changeLifecycle = function (){
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/views/lifecycle_selector_dialog.html',
            controller: 'ProjectLifecycleSelectorDialogController',
            resolve: {
                projectId: function () { return $scope.project.Id; }
            }
        }).result.then(function(result) {
            if (result) {
                $state.reload();
            }
        });
    };

    $scope.changeProjectConnectivityPolicy = function () {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/views/target_settings_dialog.html',
            controller: 'TargetSettingsDialogController',
            resolve: {
                projectId: function () { return $scope.project.Id; }
            }
        }).result.then(function(result) {
            if (result) {
                $state.reload();
            }
        });
    };

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_process_controller.js
// module id = 520
// module chunks = 1